/** Decorative indicator rendered (in red) after a required field's label text. */
export const REQUIRED_FIELD_INDICATOR = '*';
